import Model from '@/core/classes/Model'

export default class Server extends Model {
  /**
   * Generate server urls
   *
   * @param {{ postfix }} options
   *
   * @return {String[]}
   */
  generateUrls ({ postfix } = { postfix: '' }) {
    return this.get('urls').map(url => `${url}${postfix}`)
  }

  /**
   * Check if current server has multiple urls
   *
   * @return {Boolean}
   */
  hasMultipleUrls () {
    return this.get('urls').length > 1
  }

  /**
   * Get the length of urls count
   *
   * @return {Number}
   */
  rankLength () {
    return this.get('urls').length.toString().length
  }

  /**
   * Generate server url name
   *
   * @param {Number} index
   *
   * @return {String}
   */
  generateUrlName (index, label) {
    return this.hasMultipleUrls()
      ? `${label || this.get('label')}_${index.toString().padStart(this.rankLength(), '0')}`
      : label || this.get('label')
  }
}
